import React from 'react';
import PropTypes from 'prop-types';
import { SparkIcon, Toggle, TooltipTrigger } from '@spark';
import { HELP_TEXTS } from '@/features/datasets/components/DataCollection/GenerateDataWithAI/constants';

/**
 * Right-aligned "Show Advanced Settings" row: 12px label, help icon, and a
 * Spark toggle (Figma 44x22 = Toggle medium).
 */
const AdvancedSettingsRow = ({ open, onToggle }) => (
    <div className="gdai-advanced-row">
        <span className="gdai-advanced-row__label fs-unmask">Show Advanced Settings</span>
        <TooltipTrigger text={HELP_TEXTS.advancedSettings}>
            <span className="gdai-advanced-row__help">
                <SparkIcon slug="circle-help" size="small" />
            </span>
        </TooltipTrigger>
        <Toggle
            active={open}
            size="medium"
            aria-label="Show advanced settings"
            onChange={(event) => onToggle(event.target.checked)}
        />
    </div>
);

AdvancedSettingsRow.propTypes = {
    open: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default AdvancedSettingsRow;
